<fcp-form-field
    class="fcp-search"
    width="fluid"
    [compact]="compact"
    [ngClass]="{
        'fcp-search-compact': compact || size === sizeEnum.Compact,
        'fcp-search-default': size === sizeEnum.Default,
        'fcp-search-fluid': size === sizeEnum.Fluid,
        'fcp-search-disabled': disabled
    }"
>
    <fcp-icon
        *ngIf="prefix"
        fcpFieldPrefix
        [icon]="['fal', prefix]"
        [style]="
            'margin-right: 8px;' +
            (compact || size === sizeEnum.Compact
                ? 'font-size: var(--text-size-l);'
                : 'font-size: var(--text-size-xxl);')
        "
    ></fcp-icon>
    <input
        type="text"
        fcpInput
        [placeholder]="placeholder"
        [value]="searchQuery"
        (keyup)="handleSearchQueryChange($event.target.value)"
        autocapitalize="none"
        [disabled]="disabled"
        data-e2e-hook="fcp-search"
    />
    <button fcpFieldSuffix fcp-button color="transparent" *ngIf="!!searchQuery">
        <fcp-icon
            [icon]="['fal', 'times']"
            (click)="handleSearchQueryChange('')"
            [style]="
                'color: var(--interactive-14);' +
                (compact || size === sizeEnum.Compact
                    ? 'font-size: var(--text-size-l);'
                    : 'font-size: var(--text-size-xxl);')
            "
        ></fcp-icon>
    </button>
</fcp-form-field>
